import { render, staticRenderFns } from "./RouterLinkOrAnchorTag.vue?vue&type=template&id=06a96f78"
import script from "./RouterLinkOrAnchorTag.vue?vue&type=script&lang=js"
export * from "./RouterLinkOrAnchorTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports